<ui-input-group [uiSuffix]="clearButton" [uiPrefix]="''" uiSize="large">
  <input #inputField [(ngModel)]="value" [placeholder]="uiPlaceholder" (ngModelChange)="onChange($event)" ui-input data-test-id="search-input" />
</ui-input-group>
<ng-template #clearButton>
  <button *ngIf="value.length > 0" (click)="clearSearch()" ui-button>
    <i ui-icon uiType="close-big"></i>
  </button>
</ng-template>
